module.exports = __webpack_public_path__ + "static/media/bg-section.c6907105.jpg";